export interface IShareFilterData {
    emails: string[];
    filterId: string;
}

export class ShareFilterData implements IShareFilterData {
    public emails: string[];
    public filterId: string;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IShareFilterData);
    constructor(obj?: any) {
        this.filterId = (obj && obj.id) || '';
        this.emails = [];
        if (obj && obj.emails) {
            obj.emails.forEach((item: string) => {
                this.emails.push(item);
            });
        }
    }
}
